module.exports = __webpack_public_path__ + "img/QRJde.b1aabb4b.png";